/**
 * Regional Quick Select groupings.
 * Each region maps to the muscle ids (matching BodyDiagram MUSCLE_LABELS) that
 * are commonly addressed when a therapist says "work the X region".
 *
 * Order matters — chip order on UI is the order here.
 */
export const REGION_GROUPS = [
  {
    id: "neck",
    label: "Neck",
    muscles: [
      "scm",
      "scalenes",
      "platysma",
      "longus_colli",
      "suboccipitals",
      "splenius_capitis",
      "splenius_cervicis",
      "semispinalis_capitis",
      "semispinalis_cervicis",
      "multifidus_cervicis",
      "levator_scapulae",
    ],
  },
  {
    id: "shoulders",
    label: "Shoulders",
    muscles: [
      "anterior_deltoid",
      "lateral_deltoid",
      "posterior_deltoid",
      "supraspinatus",
      "infraspinatus",
      "teres_minor",
      "teres_major",
    ],
  },
  {
    id: "upper_back",
    label: "Upper Back",
    muscles: ["upper_trapezius", "middle_trapezius", "rhomboids", "levator_scapulae"],
  },
  {
    id: "mid_back",
    label: "Mid Back",
    muscles: ["lower_trapezius", "lats_upper", "erector_spinae"],
  },
  {
    id: "lower_back",
    label: "Lower Back",
    muscles: [
      "erector_spinae",
      "quadratus_lumborum",
      "thoracolumbar_fascia",
      "lats_lower",
    ],
  },
  {
    id: "chest",
    label: "Chest / Pecs",
    muscles: ["pec_major_clavicular", "pec_major_sternal", "pec_minor", "serratus_anterior"],
  },
  {
    id: "abdomen",
    label: "Abdomen / Core",
    muscles: [
      "rectus_abdominis_upper",
      "rectus_abdominis_lower",
      "external_obliques",
      "psoas_iliacus",
    ],
  },
  {
    id: "glutes",
    label: "Glutes",
    muscles: ["gluteus_maximus", "gluteus_medius", "piriformis"],
  },
  {
    id: "hip_flexors",
    label: "Hip Flexors",
    muscles: ["psoas_iliacus", "tfl", "sartorius", "rectus_femoris", "adductor_longus", "adductor_magnus"],
  },
  {
    id: "quads",
    label: "Quads",
    muscles: ["rectus_femoris", "vastus_lateralis", "vastus_medialis", "sartorius", "IT_band"],
  },
  {
    id: "hamstrings",
    label: "Hamstrings",
    muscles: ["biceps_femoris", "semitendinosus", "semimembranosus", "gracilis"],
  },
  {
    id: "calves",
    label: "Calves",
    muscles: ["gastrocnemius_medial", "gastrocnemius_lateral", "soleus", "tibialis_anterior", "peroneals"],
  },
  {
    id: "feet",
    label: "Feet",
    // Diagram-level proxy: muscles attaching at the foot/ankle.
    muscles: ["tibialis_anterior", "peroneals", "soleus"],
  },
  {
    id: "hands_forearms",
    label: "Hands / Forearms",
    muscles: ["wrist_flexors", "wrist_extensors", "brachioradialis", "biceps_brachii", "brachialis", "triceps_long", "triceps_lateral"],
  },
];

export const REGION_BY_ID = Object.fromEntries(REGION_GROUPS.map((r) => [r.id, r]));
